import { render, staticRenderFns } from "./WatchData.vue?vue&type=template&id=52aa5dc2&scoped=true&"
import script from "./WatchData.vue?vue&type=script&lang=js&"
export * from "./WatchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa5dc2",
  null
  
)

export default component.exports